import { useQuery } from '@apollo/client/react/hooks'
import { useMemo } from 'react'
import {
  ContentPolicyList_YiQueryDocument,
  ContentPolicyList_YiQueryQuery,
  ContentPolicyList_YiQueryQueryVariables,
} from './ContentPolicyListYIQuery.generated'
import { extractContentPolicyId } from './extractContentPolicyId'

export function useFetchYIContentPolicyId () {
  const { data, ...rest } = useQuery<
  ContentPolicyList_YiQueryQuery,
  ContentPolicyList_YiQueryQueryVariables
  >(ContentPolicyList_YiQueryDocument)

  const policyId = useMemo(() => extractContentPolicyId(data), [data])

  return {
    policyId,
    data,
    ...rest,
  }
}
